module.exports = __webpack_public_path__ + "static/img/lyxb2.d7843ae5.png";